var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111_3410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111_3410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1126 5.33241L16.4143 4.92276L16.4829 5.96552H10.4325H4.3109V4.93672L3.62194 5.33241C3.51555 5.38807 3.39177 5.40046 3.27645 5.36701C3.16114 5.33356 3.06322 5.25684 3.00313 5.15289C2.94304 5.04894 2.92544 4.92579 2.95401 4.80917C2.98257 4.69255 3.05509 4.59148 3.15642 4.52707L10.276 1L17.5781 4.52707C17.6338 4.55617 17.6829 4.59623 17.7227 4.64482C17.7624 4.69342 17.792 4.74956 17.8094 4.80985C17.8269 4.87015 17.8321 4.93336 17.8245 4.99569C17.8169 5.05802 17.7968 5.11817 17.7654 5.17252C17.734 5.22688 17.6919 5.27432 17.6417 5.31198C17.5914 5.34965 17.5341 5.37677 17.4731 5.39171C17.4121 5.40664 17.3488 5.40909 17.2868 5.3989C17.2249 5.38871 17.1656 5.3661 17.1126 5.33241ZM10.4325 2.32983C10.3758 2.29714 10.3116 2.27993 10.2462 2.27993C10.1809 2.27993 10.1167 2.29714 10.06 2.32983L5.31044 4.72414L8.41389 4.64482H10.2462L12.138 4.72414H15.2415L10.4325 2.32983Z",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84554 11.5885H3.44985C3.44205 11.5885 3.43426 11.5886 3.4265 11.589H17.2991C17.2913 11.5886 17.2835 11.5885 17.2757 11.5885H16.88V11.1928C16.88 11.0508 16.8236 10.9146 16.7232 10.8142C16.6228 10.7138 16.4867 10.6574 16.3447 10.6574H15.018V7.22656H13.1559V10.6574H11.2938V7.22656H9.43175V10.6574H7.56968V7.22656H5.70761V10.6574H4.38089C4.2389 10.6574 4.10274 10.7138 4.00234 10.8142C3.90194 10.9146 3.84554 11.0508 3.84554 11.1928V11.5885Z",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8369 15.6818V12.8887H9.96849M9.96849 12.8887V15.6818M9.96849 12.8887H3.33691V15.6818",
    stroke: "#111111",
    strokeOpacity: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.39655,
    transform: "matrix(-1 0 0 1 16.8967 17.6036)",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.39655,
    transform: "matrix(-1 0 0 1 9.91375 17.6036)",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.39655,
    transform: "matrix(-1 0 0 1 3.39666 17.6036)",
    fill: "#111111",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.d0bb45b89c56df865c054ef000283749.svg";
export { ForwardRef as ReactComponent };